import moment from 'moment'
import * as Yup from 'yup'
import { isValidNumber } from 'libphonenumber-js'

export const validRequired = (value) =>
  !value ? 'This field is required' : undefined

export const validNumber = (value) =>
  value < 0 || value === undefined ? 'This field is required' : undefined

export const validTime = (value) => {
  const formats = [
    'h:m',
    'h:ma',
    'h:m A',
    'h:m a',
    'h:m A',
    'h:mm',
    'h:mma',
    'h:mmA',
    'h:mm a',
    'h:mm A',
    'hh:m',
    'hh:ma',
    'hh:mA',
    'hh:m a',
    'hh:m A',
    'H:m',
    'H:ma',
    'H:m A',
    'H:m a',
    'H:m A',
    'H:mm',
    'H:mma',
    'H:mmA',
    'H:mm a',
    'H:mm A',
    'HH:m',
    'HH:ma',
    'HH:mA',
    'HH:m a',
    'HH:m A',
  ]

  if (!moment(value, formats, true).isValid()) {
    return 'Not a valid time'
  }

  return undefined
}

export const validDateOfBirth = (value) => {
  // Do not assume the year with only 2-digits.
  moment.parseTwoDigitYear = (yearString) => parseInt(yearString, 10)

  const birthday = moment(value, 'DD/MM/YYYY')
  const age = moment().diff(birthday, 'years')

  if (birthday.year() < 1900) {
    return 'Not a valid date'
  }

  if (age < 18) {
    return 'You need to be at least 18 years of age'
  }

  return undefined
}

export const validEmail = (value) => {
  const schema = Yup.string().email()
  return schema.isValidSync(value) ? undefined : 'Not a valid email'
}

export const validPassword = (_value, values) => {
  if (values.user.password && values.user.password.length < 8) {
    return 'Password should be at least 8+ characters'
  }

  if (values.user.password !== values.user.password_confirmation) {
    return 'Password confirmation should match password'
  }

  return undefined
}

export const validURL = (value) => {
  const schema = Yup.string().url()
  return value && (schema.isValidSync(value) ? undefined : 'Not a valid URL')
}

export const validVerifiedPhoneNumber = (value) =>
  !value ? 'You need to verify this number' : undefined

/**
 * value can be either:
 * - a JSON upload result from uppy
 * - an image object from our API (included in form's initial values)
 */
export const validImage = (value) => {
  const errorMsg = 'Please upload an image'

  // handle when value is an image object form our API
  if (typeof value === 'object') {
    const objValues = Object.values(value)
    const nonEmptyFields = objValues.filter((v) => v?.length > 0)

    return nonEmptyFields.length > 0 ? undefined : errorMsg
  }

  /**
   * handle when value is a new upload result from uppy
   */
  try {
    JSON.parse(value)
  } catch (error) {
    return errorMsg
  }

  return undefined
}

export const normalizeBoolean = (value) => {
  if (value === 'true') {
    return true
  }

  if (value === 'false') {
    return false
  }

  return value
}

export const validBoolean = (value) =>
  typeof value !== 'boolean' ? 'This field is required' : undefined

export const validCheckboxGroup = (values) =>
  values && values.filter((k) => !!k).length < 1
    ? 'Please select at least one'
    : undefined

export const validArrayOfMinimumOneImage = (value) =>
  value && value.length < 1 ? 'Please upload at least one image' : undefined

export const validPhoneNumber = (value) => {
  if (value && !isValidNumber(value)) {
    return 'Not a valid phone number'
  }

  return undefined
}
